import Star from '../assests/RatingStar.png';
export const LOGIN = Object.freeze({
  DONT_HAVE_TEXT: 'Don’t have an account?',
  WELCOME_HEADING: 'Welcome back!',
  BTN_TEXT_LOGIN: 'Log in',
  SIGN_UP_TEXT: 'Sign up',
  FORGOTE_PASS_TEXT: 'Forgot Password ?',
  LABEL: {
    email: 'Email',
    password: 'Password',
  },
  PLACE_HOLDER: {
    email: 'john@gmail.com',
    password: 'Enter password',
  },
  ERROR: {
    email: 'Email is required',
    password: 'Please enter password',
  },
});

export const FORGOTE_PASSWORD = Object.freeze({
  HEAD_TO_LOGIN: 'Head to Login?',
  BTN_TEXT_LOGIN: 'Login',
  PASS_CHANGED_SUCCESS: 'Password changed successfully!',
  FORGOT_PASS: 'Forgot Password',
  ENTER_LINKED_PHONE: 'Please enter the phone number linked to your account',
  ENTER_PHONE_NUMBER: 'Enter phone number',
  SEND_OTP: 'We’ll send an OTP for confirmation',
  PHONE_NUMBER_VERIFY_SUCCESS: 'Phone number verified successfully.',
});
export const CHANGE_PASSWORD = Object.freeze({
  OTP_SEND_SUCCESS: 'OTP Sent Successfully.',
  OTP_RESEND_SUCCESS: 'OTP Resent Successfully.',
  WRONG_OTP: 'Wrong OTP entered. Please retry.',
  SAVE_CHANGES: 'Save Changes',
});
export const CREATE_PASSWORD = Object.freeze({
  TITLE: 'Create New Password',
  CHANGE_PASSWORD: 'Change Password',

  LABEL: {
    password: 'Password',
    confirm_password: 'Confirm Password',
  },
  PLACE_HOLDER: {
    password: 'Enter password',
    confirm_password: 'Confirm password',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while changing password.',
    BY_ID: 'Something went wrong while fetching visit request.',
  },
});

export const SIGNUP = Object.freeze({
  MEMBER_DETAILS_TEXT: 'Member Details',
  NEW_USER_REGISTER_TEXT: 'New User Registration',
  BTN_TEXT_CREATE_ACCOUNT: 'Create Account',
  BTN_TEXT_BACK: 'Back',
  BTN_TEXT_PROCEED: 'Proceed',
  BTN_TEXT_LOGIN: 'Login',
  HAVE_ACCOUNT_TEXT: 'Have an account?',
  FIRST_NAME: 'firstname',
  LAST_NAME: 'lastname',
  DATE: 'date',
  SSN: 'ssn',
  ZIPCODE: 'zipcode',
  PHONE_NUMBER: 'phonenumber',
  RADIO_BUTTON_LABEL: {
    member: 'Member ID',
    security: 'Social Security Number',
  },
  LABEL: {
    email: 'Email',
    phone: 'Phone Number',
    password: 'Password',
    confirm_password: 'Confirm Password',
  },
  PLACE_HOLDER: {
    email: 'john@gmail.com',
    phone: 'Enter phone number',
    password: 'Enter password',
    confirm_password: 'Confirm password',
  },
  OTP_CONFIRMATION_TEXT: 'We’ll send a OTP to confirm your number',
  PRIVACY_POLICY_TEXT: 'I accept the',
});
export const VISIT = Object.freeze({
  TITLE_TEXT: 'Visits',
  VAR_VISIT_TYPE: 'ALL',
  SEARCH_PLACEHOLDER_TEXT: 'Search by Visits',
  MODAL_DATA: {
    STATUS: 'Status',
    RECORDED_ON: 'Recorded On',
    RECORDED_BY: 'Recorded By',
    VISIT_TYPE: 'Visit Type',
    PROVIDER: 'Provider',
    LAST_VISITED: 'Last visited on',
    PROVIDER_SPECIALITY: 'Provider speciality',
    SERVICE_TYPE: 'Service type',
    DOCUMENTS: 'Document',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Visits.',
    BY_ID: 'Something went wrong while fetching visit request.',
    CATCH_NETWORK_TEXT: 'cache-and-network',
    VARIANT_TEXT: 'error',
  },
});

export const ASSESSMENT_LIST = Object.freeze({
  ERROR_MESSAGE: 'Something went wrong while fetching Assessments.',
});

export const MEDICAL = Object.freeze({
  TITLE_TEXT: 'Medical',
});

export const VISIT_TABLE_HEADING = [
  { label: 'Recorded on', key: 'recordedOn', width: 100 },
  { label: 'Facility', key: 'facility', width: 100 },
  { label: 'Type of visit', key: 'typeOfVisitValue', width: 500 },
  { label: 'Status', key: 'status', width: 100 },
  { label: 'Provider', key: 'provider', width: 100 },
  { label: 'More', key: 'more' },
];

export const VISIT_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Visits' },
];

export const VITALS = Object.freeze({
  TITLE_TEXT: 'Vitals',
  NO_DATA_FOUND: 'No Data Found',
  SHOW_ALL_TEXT: 'Show All',
  BLOOD_PRESSURE: 'BLOOD_PRESSURE',
  HEART_RATE: 'HEART_RATE',
  RESPIRATORY_RATE: 'RESPIRATORY_RATE',
  BODY_TEMPERATURE: 'BODY_TEMPERATURE',
  IMAGE_ALTERNATE_TEXT: {
    BLOOD_PRESSURE: 'Blood Pressure',
    HEART_RATE: 'Heart Rate',
    LUNGS: 'Lungs',
    BODY_TEMPERATURE: 'Body Temperature',
  },

  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching vitals.',
    BY_ID: 'Something went wrong while fetching visit request.',
  },
});

export const VITALS_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Vitals' },
];

export const VITAL_CHART = Object.freeze({
  RANGE: 'RANGE',
});

export const MEDICATIONS = Object.freeze({
  TITLE_TEXT: 'Medications',
  MEDICATIONS_DISPENSE_TEXT: 'MedicationDispense',
  MEDICATIONS_STATEMENT_TEXT: 'MedicationStatement',
  SEARCH_PLACEHOLDER_TEXT: 'Search by medication code',

  MODAL_DATA: {
    STATUS: 'Status',
    RECORDED_ON: 'Recorded On',
    MEDICATION_TYPE: 'Type Of Medication',
    DOSAGE: 'Dosage',
    RECORDED_BY: 'Recorded By',
    PRESCRIBER: 'Prescriber',
    CODE: 'Code',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    INGREDIENTS: 'Ingredients',
    FREQUENCY: 'Frequency',
    MANUFACTURE: 'Manufacturer',
    REQUESTED_BY: 'Requested By',
    NOTE: 'Note',
  },
  ON_ERROR_TEXT: {
    ALL_MEDICATIONS: 'Something went wrong while fetching Medications.',
    MEDICATION_STATEMENT:
      'Something went wrong while fetching medication statement.',
    MEDICATION_DISPENSE:
      'Something went wrong while fetching medication dispense.',

    BY_ID: 'Something went wrong while fetching medication request.',
  },
});

export const MEDICATIONS_TABLE_HEADING = [
  { label: 'Recorded on', key: 'recordedOn', width: 100 },
  { label: 'Medication', key: 'medication', width: 100 },
  { label: 'Status', key: 'status', width: 100 },
  { label: 'Frequency', key: 'frequency', width: 100 },
  //{ label: 'Prescriber', key: 'prescriber' },
  //{ label: 'Pharmacy', key: 'pharmacy' },
  { label: 'Dosage', key: 'dosage', width: 380 },
  { label: 'More' },
];

export const MEDICATIONS_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Medications' },
];

export const PROCEDURES = Object.freeze({
  TITLE_TEXT: 'Procedures',
  SEARCH_PLACEHOLDER_TEXT: 'Search by Procedures',

  MODAL_DATA: {
    STATUS: 'Status',
    RECORDED_ON: 'Recorded On',
    FACILITY: 'Facility',
    CODE: 'Code',
    OUTCOME: 'Outcome',
    COMPLICATIONS: 'Complications',
    CATEGORY: 'Category',
    FOLLOW_UP: 'Follow Up',
    RECORDED_BY: 'Recorded By',
    REASON_CODE: 'Reason Code',
    BODY_SITE: 'Body Site',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Procedures.',
    BY_ID: 'Something went wrong while fetching Procedure Details',
  },
});

export const PROCEDURES_TABLE_HEADING = [
  { label: 'Recorded on', key: 'recordedOn', width: 150 },
  { label: 'Procedure', key: 'procedure', width: 400 },
  { label: 'Status', key: 'status', width: 150 },
  { label: 'Outcome', key: 'outcome', width: 250 },
  { label: 'More' },
];

export const PROCEDURES_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Procedures' },
];

export const ALLERGIES = Object.freeze({
  TITLE_TEXT: 'Allergies',
  SEARCH_PLACEHOLDER_TEXT: 'Search by allergy code',

  MODAL_DATA: {
    STATUS: 'Status',
    RECORDED_ON: 'Recorded On',
    RECORDED_BY: 'Recorded By',
    FACILITY: 'Facility',
    CODE: 'Code',
    CRITICALITY: 'Criticality',
    CATEGORY: 'Category',
    ROUTE: 'Route',
    REACTION: 'Reaction',
    NOTE: 'Note',
    DOCUMENTS: 'Document',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Allergies.',
    BY_ID: 'Something went wrong while fetching Allergies Details',
  },
});

export const ALLERGIES_TABLE_HEADING = [
  { label: 'Recorded on', key: 'recordedOn', width: 250 },
  { label: 'Allergic to', key: 'allergicTo', width: 350 },
  { label: 'Status', key: 'status', width: 250 },
  { label: 'Criticality', key: 'criticality', width: 250 },
  { label: 'More' },
];
export const ALLERGIES_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Allergies' },
];

export const LAB = Object.freeze({
  TITLE_TEXT: 'Lab Results',
  SEARCH_PLACEHOLDER_TEXT: 'Search by lab result code',

  MODAL_DATA: {
    STATUS: 'Status',
    RECORDED_ON: 'Recorded On',
    RECORDED_BY: 'Recorded By',
    VALUE: 'Value',
    REFERENCE_RANGE: 'Reference Range',
    FACILITY: 'Facility',
    TEST_RESULT: 'Test Result',
    ISSUED_DATE: 'Issued Date',
    ISSUER_OF_REPORT: 'Issuer Of The Report',
    CATEGORY_CODE: 'Category Code',
    LOINC_CODE: 'LOINC Code',
    NOTE: 'Note',
    DOCUMENTS: 'Document',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching lab results.',
    BY_ID: 'Something went wrong while fetching lab results request.',
  },
});

export const LAB_RESULT_TABLE_HEADING = [
  { label: 'Recorded on', key: 'recordedOn', width: 150 },
  { label: 'Name', key: 'name', width: 500 },
  { label: 'Status', key: 'status', width: 150 },
  { label: 'Category', key: 'category', width: 150 },
  { label: 'More' },
];

export const LAB_RESULT_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Lab Results' },
];

export const DOCUMENTS = Object.freeze({
  TITLE_TEXT: 'Documents',
  SEARCH_PLACEHOLDER_TEXT: 'Search by document code',

  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Documents.',
  },
});
export const DOCUMENTS_TABLE_HEADING = [
  { label: 'Document name', key: 'documentName' },
  { label: 'Type', key: 'type' },
  { label: 'Facility', key: 'facility' },
  { label: 'Recorded by', key: 'recordedBy' },
  { label: 'Download', key: 'download' },
];
export const DOCUMENTS_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Documents' },
];

export const IMMUNIZATIONS = Object.freeze({
  TITLE_TEXT: 'Immunizations',
  SEARCH_PLACEHOLDER_TEXT: 'Search by immunization code',

  MODAL_DATA: {
    STATUS: 'Status',
    RECORDED_ON: 'Recorded On',
    RECORDED_BY: 'Recorded By',
    BODY_SITE: 'Body Site',
    ROUTE: 'Route',
    DOSES: 'Doses',
    NDC_CODE: 'NDC Code',
    VACCINE_LOT_NO: 'Vaccine Lot No.',
    VACCINE_MANUFACTURER: 'Vaccine Manufacturer',
    VACCINE_DOSE_NO: 'Vaccine Dose No.',
    REASON: 'Reason',
    REACTION: 'Reaction',
    FACILITY: 'Facility',
    NOTE: 'Note',
    DOCUMENTS: 'Document',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Immunizations.',
    BY_ID: 'Something went wrong while fetching Immunizations Details',
  },
});
export const IMMUNIZATIONS_TABLE_HEADING = [
  { label: 'Recorded on', key: 'recordedOn' },
  { label: 'Immunization', key: 'immunization' },
  { label: 'Status', key: 'status' },
  { label: 'Dose', key: 'dose' },
  //{ label: 'Recorded By', key: 'recordedBy' },
  //{ label: 'Facility', key: 'facility' },
  { label: 'More' },
];

export const IMMUNIZATIONS_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Immunizations' },
];

export const CONDITIONS = Object.freeze({
  TITLE_TEXT: 'Conditions',
  SEARCH_PLACEHOLDER_TEXT: 'Search by condition code',

  MODAL_DATA: {
    STATUS: 'Status',
    RECORDED_ON: 'Recorded On',
    RECORDED_BY: 'Recorded By',
    FACILITY: 'Facility',
    CATEGORY: 'Category',
    CODE: 'Code',
    SERVERITY: 'Severity',
    SUMMARY: 'Summary',
    NOTE: 'Note',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Conditions.',
    BY_ID: 'Something went wrong while fetching Conditions Details',
  },
});

export const CONDITIONS_TABLE_HEADING = [
  { label: 'Recorded on', key: 'recordedOn', width: 160 },
  { label: 'Condition', key: 'condition', width: 500 },
  { label: 'Status', key: 'status', width: 160 },
  { label: 'Severity', key: 'severity', width: 160 },
  //{ label: 'Recorded By', key: 'recordedBy' },
  //{ label: 'Facility', key: 'facility' },
  { label: 'More' },
];
export const CONDITIONS_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Conditions' },
];

export const SOCIAL_HISTORY = Object.freeze({
  TITLE_TEXT: 'Social History',
  SEARCH_PLACEHOLDER_TEXT: 'Search by Social history code',

  MODAL_DATA: {
    STATUS: 'Status',
    RECORDED_ON: 'Recorded On',
    RECORDED_BY: 'Recorded By',
    FREQUENCY: 'Frequency',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT:
      'Something went wrong while fetching Social History Statements.',
  },
});

export const SOCIAL_HISTORY_TABLE_HEADING = [
  { label: 'Recorded on', key: 'recordedOn' },
  { label: 'Name', key: 'name' },
  { label: 'Status', key: 'status' },
  { label: 'Frequency', key: 'frequency' },
  { label: 'Recorded by', key: 'recordedBy' },
  { label: 'More', key: 'more' },
];
export const SOCIAL_HISTORY_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Social History' },
];

export const PRIOR_AUTHORIZATION = Object.freeze({
  TITLE_TEXT: 'Prior Authorization',
  SEARCH_PLACEHOLDER_TEXT: 'Search by Authorization',

  MODAL_DATA: {
    SERVICE: 'Service (CPT Code)',
    REQUESTING_PROVIDER: 'Requesting Provider',
    REQUEST_PRIORITY: 'Request Priority',
    REQUESTED_DATE: 'Requested Date',
    DUE_DATE: 'Due Date',
    STATUS: 'Status',
    SERVICE_LOCATION: 'Service Location',
    SERVICE_START_DATE: 'Service Start Date',
    SERVICE_END_DATE: 'Service End Date',
    DIAGNOSIS: 'Diagnosis',
    UNITS: 'Units',
    PRIOR_AUTH_ID: 'Prior Auth ID',
    DOCUMENTS: 'Documents',
    NOTES: 'Notes',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Prior Authorization.',
    BY_ID: 'Something went wrong while fetching Prior Authorization Details',
  },
});

export const PRIOR_AUTHORIZATION_TABLE_HEADING = [
  { label: 'Name', key: 'name', width: 350 },
  //{ label: 'Requesting Provider', key: 'requestingProvider' },
  { label: 'Status', key: 'status', width: 150 },
  { label: 'Priority', key: 'priority', width: 150 },
  { label: 'Request date', key: 'requestDate', width: 150 },
  { label: 'Due date', key: 'dueDate', width: 150 },

  { label: 'More', key: 'more' },
];
export const PRIOR_AUTHORIZATION_BREADCRUMBDATA = [
  { label: 'Financial', route: '/financial' },
  { label: 'Prior Authorization' },
];

export const ACCOUNT = Object.freeze({
  TITLE_TEXT: 'Account',
});
export const ACCOUNT_DETAILS = Object.freeze({
  TITLE_TEXT: 'Account Details',
  PERSONAL_DETAILS_TEXT: 'Personal Details',
  CONTACT_DETAILS_TEXT: 'Contact Details',
  DETAILS: {
    FULL_NAME: 'Full Name',
    PREFERRED_NAME: 'Preferred Name',
    GENDER: 'Gender',
    USER_ID: 'User ID',
    DATE_OF_BIRTH: 'Date of Birth',
    BLOOD_GROUP: 'Blood Group',
    PRIMARY_EMAIL_ADDRESS: 'Primary Email Address',
    PRIMARY_PHONE_NUMBER: 'Primary Phone Number',
    PRIMARY_ADDRESS: 'Primary Address',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching account details',
  },
});
export const ACCOUNT_DETAILS_BREADCRUMBDATA = [
  { label: 'Account', route: '/account' },
  { label: 'Account Details' },
];
export const BILLS = Object.freeze({
  TITLE_TEXT: 'Bills',
  BILL_SUMMARY: 'Bill Summary',
  AMOUNT: 'Amount',
  PAYMENT_DETAILS: 'Payment Details',
  PAYMENT_ID: 'Payment ID',
  PAID_BY_PLAN: 'Paid by plan',
  SERVICES: 'Services',
  PAID_PLAN_AMOUNT: 'Paid Plan Amount',
  COPAY_AMOUNT: 'Copay Amount',
  PAYMENT_BREAKUP: 'Payment breakup',
  PROMO_CODE: 'PromoCode',
  PAID_AMOUNT: 'Paid Amount',
  title: 'Bills',
  DUE_NEXT_WEEK: 'Due Next Week',
  PAY_BILL: 'Pay Bill',
  VIEW_DETAILS: 'View Details',
  TOTAL_BILL_DUE: 'Total bills due',
  NO_OF_BILLS: 'No of bills:',
  EXPENDITURE: 'Expenditure',

  IMAGE_ALTERNATE_TEXT: {
    ICON: 'icon',
  },

  SEARCH_PLACEHOLDER_TEXT: 'Search by Bills',

  MODAL_DATA: {
    BILL_ID: 'Bill ID',
    SERVICE_DATE: 'Service date',
    FACILITY: 'Facility',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Bills.',
    WENT_WRONG_SUMMARY_TEXT:
      'Something went wrong while fetching get metadata for Bills Summary.',
    BY_ID: 'Something went wrong while fetching Bills request.',
    WENT_WRONG_DUE_BILLS: 'Something went wrong while fetching due .',
  },
});

export const BILLS_TABLE_HEADING = [
  { label: 'Date', key: 'recordedOn' },
  { label: 'Bill id', key: 'id' },
  { label: 'Facility', key: 'facility' },
  { label: 'Amount', key: 'amount' },
  { label: 'Status', key: 'status' },
  { label: 'More', key: 'more' },
];
export const BILLS_BREADCRUMBDATA = [
  { label: 'Financial', route: '/financial' },
  { label: 'Bills' },
];

export const CLAIMS_DATA = Object.freeze({
  TITLE_TEXT: 'Claims',
  SEARCH_PLACEHOLDER_TEXT: 'Search by Claims',

  MODAL_DATA: {
    STATUS: 'Status',
    PROVIDER: 'Provider',
    CLAIM_TYPE: 'Claim Type',
    CTREATED_ON: 'Created On',
    CLAIM_AMOUNT: 'Claim Amount',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Claims.',
    BY_ID: 'Something went wrong fetching Claims Details',
  },
});

export const CLAIMS_DATA_TABLE_HEADING = [
  { label: 'Created on', key: 'recordedOn' },
  { label: 'Claim number', key: 'claimNumber' },
  { label: 'Claim type', key: 'claimType' },
  { label: 'Status', key: 'status' },
  { label: 'Provider', key: 'provider' },
  { label: 'Claim amount', key: 'claimAmount' },
  { label: 'More', key: 'more' },
];
export const CLAIMS_DATA_BREADCRUMBDATA = [
  { label: 'Financial', route: '/financial' },
  { label: 'Claims' },
];

export const CONSENT = Object.freeze({
  TITLE_TEXT: 'Consents',
  CONSENT_DETAILS: 'Consent Details',
  SEARCH_PLACEHOLDER_TEXT: 'Search by Consents',
});

export const ASSESSMENT = Object.freeze({
  TITLE_TEXT: 'Assessments',
  SEARCH_PLACEHOLDER_TEXT: 'Search by assessment name',
});
export const CONSENT_TABLE_HEADING = [
  { label: 'Received On', key: 'receivedOn' },
  { label: 'Received From', key: 'receivedFrom' },
  { label: 'Role', key: 'role' },
  { label: 'Status', key: 'status' },
  { label: 'Type of Consent', key: 'typeOfConsent' },
  { label: 'Expires On', key: 'expiresOn' },
  { label: 'More' },
];
export const CONSENT_BREADCRUMBDATA = [
  { label: 'Legal', route: '/legal' },
  { label: 'Consents' },
];

export const PROVIDERS = Object.freeze({
  PROVIDERS_TEXT: 'Providers',
  TITLE_TEXT: 'Previously Visited',
  ABOUT: 'About',
  VISIT_DETAILS: 'Visit Details',
  TYPE_VISIT: 'Type of Visit',
  PURPOSE_VISIT: 'Purpose of Visit',

  SEARCH_PLACEHOLDER_TEXT: 'Search by Care',

  LABEL_TEXT: {
    EXPERIENCE: 'experience',
    LOCATION: 'location',
    CERTIFICATION: 'certification',
    LANGUAGE: 'language',
    COST: 'cost',
    STATUS: 'status',
  },

  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Providers.',
    BY_ID: 'Something went wrong while fetching Providers.',
    WENT_WRONG_FETCHING_TIME_SLOT_TEXT:
      'Something went wrong while fetching TimeSlotByPractionerId request.',
  },
});

export const PROVIDERS_TABLE_HEADING = [
  { label: 'Provider', key: 'name' },
  { label: 'Speciality', key: 'speciality' },
  { label: 'Rating', key: 'rating' },
  { label: 'Distance', key: 'distance' },
  { label: 'Language', key: 'communication' },
  { label: 'Accepting patient', key: 'acceptingPatient' },
  { label: 'More' },
];

export const PROVIDERS_SPECIALITY_FILTER_MENU_ITEMS = [
  { label: 'All', value: 'all' },
  { label: 'Adult mental illness', value: 'Adult mental illness' },
  { label: 'Anesthetics', value: 'Anesthetics' },
  { label: 'Audiological medicine', value: 'Audiological medicine' },
  {
    label: 'Blood banking and transfusion medicine',
    value: 'Blood banking and transfusion medicine',
  },
  { label: 'Burns care', value: 'Burns care' },
  { label: 'Cardiology', value: 'Cardiology' },
  {
    label: 'Clinical cytogenetics and molecular genetics',
    value: 'Clinical cytogenetics and molecular genetics',
  },
  { label: 'Clinical genetics', value: 'Clinical genetics' },
  { label: 'Clinical hematology', value: 'Clinical hematology' },
  { label: 'Clinical immunology', value: 'Clinical immunology' },
  { label: 'Clinical microbiology', value: 'Clinical microbiology' },
  { label: 'Clinical neuro-physiology', value: 'Clinical neuro-physiology' },
  { label: 'Clinical oncology', value: 'Clinical oncology' },
  { label: 'Clinical pharmacology', value: 'Clinical pharmacology' },
  { label: 'Community medicine', value: 'Community medicine' },
  { label: 'Critical care medicine', value: 'Critical care medicine' },
  {
    label: 'Dental medicine specialties',
    value: 'Dental medicine specialties',
  },
  {
    label: 'Dental-General dental practice',
    value: 'Dental-General dental practice',
  },
  { label: 'Dermatology', value: 'Dermatology' },
  { label: 'Dive medicine', value: 'Dive medicine' },
  { label: 'Endocrinology', value: 'Endocrinology' },
  { label: 'Family practice', value: 'Family practice' },
  { label: 'Gastroenterology', value: 'Gastroenterology' },
  { label: 'General medical practice', value: 'General medical practice' },
  { label: 'General medicine', value: 'General medicine' },
  { label: 'General pathology', value: 'General pathology' },
  { label: 'General practice', value: 'General practice' },
  { label: 'Genito-urinary medicine', value: 'Genito-urinary medicine' },
  { label: 'Geriatric medicine', value: 'Geriatric medicine' },
  { label: 'Gynecological oncology', value: 'Gynecological oncology' },
  { label: 'Gynecology', value: 'Gynecology' },
  { label: 'Hematopathology	', value: 'Hematopathology' },
  { label: 'Hepatology', value: 'Hepatology' },
  { label: 'Histopathology', value: 'Histopathology' },
  { label: 'Immunopathology', value: 'Immunopathology' },
  { label: 'Infectious diseases', value: 'Infectious diseases' },
  { label: 'Internal medicine', value: 'Internal medicine' },
  { label: 'Learning disability', value: 'Learning disability' },
  { label: 'Medical oncology', value: 'Medical oncology' },
  { label: 'Medical ophthalmology', value: 'Medical ophthalmology' },
  { label: 'Military medicine	', value: 'Military medicine	' },
  { label: 'Nephrology', value: 'Nephrology' },
  { label: 'Neurology', value: 'Neurology' },
  { label: 'Neuropathology', value: 'Neuropathology' },
  { label: 'Nuclear medicine', value: 'Nuclear medicine' },
  { label: 'Obstetrics', value: 'Obstetrics' },
  { label: 'Obstetrics and gynecology', value: 'Obstetrics and gynecology' },
  { label: 'Occupational medicine', value: 'Occupational medicine' },
  { label: 'Ophthalmic surgery', value: 'Ophthalmic surgery' },
  { label: 'Ophthalmology', value: 'Ophthalmology' },
  {
    label: 'Osteopathic manipulative medicine',
    value: 'Osteopathic manipulative medicine',
  },
  { label: 'Otolaryngology', value: 'Otolaryngology' },
  { label: 'Pain management	', value: 'Pain management	' },
  { label: 'Palliative medicine', value: 'Palliative medicine' },
  {
    label: 'Pediatric (Child and adolescent) psychiatry',
    value: 'Pediatric (Child and adolescent) psychiatry',
  },
  { label: 'Pediatric cardiology', value: 'Pediatric cardiology' },
  { label: 'Pediatric dentistry', value: 'Pediatric dentistry' },
  { label: 'Pediatric endocrinology', value: 'Pediatric endocrinology' },
  { label: 'Pediatric gastroenterology', value: 'Pediatric gastroenterology' },
  { label: 'Pediatric genetics', value: 'Pediatric genetics' },
  { label: 'Pediatric hematology', value: 'Pediatric hematology' },
  { label: 'Pediatric immunology', value: 'Pediatric immunology' },
  {
    label: 'Pediatric infectious diseases',
    value: 'Pediatric infectious diseases',
  },
  { label: 'Pediatric nephrology', value: 'Pediatric nephrology' },
  { label: 'Pediatric oncology', value: 'Pediatric oncology' },
  { label: 'Pediatric ophthalmology', value: 'Pediatric ophthalmology' },
  { label: 'Pediatric pulmonology', value: 'Pediatric pulmonology' },
  { label: 'Pediatric rheumatology	', value: 'Pediatric rheumatology	' },
  { label: 'Pediatric surgery', value: 'Pediatric surgery' },
  {
    label: 'Pediatric surgery-bone marrow transplantation',
    value: 'Pediatric surgery-bone marrow transplantation',
  },
  { label: 'Preventive medicine', value: 'Preventive medicine' },
  { label: 'Psychiatryy', value: 'Psychiatry' },
  { label: 'Psychotherapy', value: 'Psychotherapy' },
  { label: 'Public health medicine', value: 'Public health medicine' },
  { label: 'Pulmonary medicine', value: 'Pulmonary medicine' },
  { label: 'Radiation oncology', value: 'Radiation oncology' },
  { label: 'Radiology', value: 'Radiology' },
  {
    label: 'Radiology-Interventional radiology',
    value: 'Radiology-Interventional radiology',
  },
  { label: 'Rehabilitation', value: 'Rehabilitation' },
  { label: 'Respite care', value: 'Respite care' },
  { label: 'Rheumatology', value: 'Rheumatology' },
  { label: 'Sleep studies', value: 'Sleep studies' },
  {
    label: 'Surgery-Bone and marrow transplantation	',
    value: 'Surgery-Bone and marrow transplantation	Pulmonary medicine',
  },
  { label: 'Surgery-Breast surgery', value: 'Surgery-Breast surgery' },
  { label: 'Surgery-Cardiac surgery	', value: 'Surgery-Cardiac surgery	' },
  {
    label: 'Surgery-Cardiothoracic transplantation',
    value: 'Surgery-Cardiothoracic transplantation',
  },
  { label: 'Surgery-Colorectal surgery', value: 'Surgery-Colorectal surgery' },
  { label: 'Surgery-Dental-Endodontics', value: 'Surgery-Dental-Endodontics' },
  {
    label: 'Surgery-Dental-Oral and maxillofacial surgery',
    value: 'Surgery-Dental-Oral and maxillofacial surgery',
  },
  {
    label: 'Surgery-Dental-Oral surgery',
    value: 'Surgery-Dental-Oral surgery',
  },
  {
    label: 'Surgery-Dental-Orthodontics',
    value: 'Surgery-Dental-Orthodontics',
  },
  {
    label: 'Surgery-Dental-Periodontal surgery',
    value: 'Surgery-Dental-Periodontal surgery',
  },
  {
    label: 'Surgery-Dental-Prosthetic dentistry (Prosthodontics)',
    value: 'Surgery-Dental-Prosthetic dentistry (Prosthodontics)',
  },
  {
    label: 'Surgery-Dental-surgical-Prosthodontics',
    value: 'Surgery-Dental-surgical-Prosthodontics',
  },
  {
    label: 'Surgery-Dentistry-Restorative dentistry',
    value: 'Surgery-Dentistry-Restorative dentistry',
  },
  {
    label: 'Surgery-Dentistry--surgical',
    value: 'Surgery-Dentistry--surgical',
  },
  {
    label: 'Surgery-Dentistry-surgical-Orthodontics',
    value: 'Surgery-Dentistry-surgical-Orthodontics',
  },
  {
    label: 'Surgery-Dermatologic surgery',
    value: 'Surgery-Dermatologic surgery',
  },
  {
    label: 'Surgery-Ear, nose and throat surgery',
    value: 'Surgery-Ear, nose and throat surgery',
  },
  { label: 'Surgery-general	', value: 'Surgery-general	' },
  {
    label: 'Surgery-Hepatobiliary and pancreatic surgery',
    value: 'Surgery-Hepatobiliary and pancreatic surgery',
  },
  { label: 'Surgery-Neurosurgery', value: 'Surgery-Neurosurgery' },
  { label: 'Surgery-Plastic surgery', value: 'Surgery-Plastic surgery' },
  {
    label: 'Surgery-Transplantation surgery',
    value: 'Surgery-Transplantation surgery',
  },
  {
    label: 'Surgery-Trauma and orthopedics',
    value: 'Surgery-Trauma and orthopedics',
  },
  { label: 'Surgery-Vascular', value: 'Surgery-Vascular' },
  { label: 'Surgical oncology', value: 'Surgical oncology' },
  {
    label: 'Surgical-Accident & emergency',
    value: 'Surgical-Accident & emergency',
  },
  { label: 'Thoracic medicine', value: 'Thoracic medicine' },
  { label: 'Toxicology', value: 'Toxicology' },
  { label: 'Tropical medicine', value: 'Tropical medicine' },
  { label: 'Urological oncology', value: 'Urological oncology' },
  { label: 'Urology', value: 'Urology' },
  //{ label: 'Medical specialty', value: 'Medical specialty' },
  //{ label: 'Surgical specialty', value: 'Surgical specialty' },
  { label: 'Others', value: 'Others' },
];

export const PROVIDERS_LANGUAGE_FILTER_MENU_ITEMS = [
  { label: 'All', value: 'all' },
  { label: 'English', value: 'English' },
  { label: 'German', value: 'German' },
  { label: 'French', value: 'French' },
];

export const PROVIDERS_DISTANCE_FILTER_MENU_ITEMS = [
  { label: 'All', value: 'all' },
  { label: '1 mi', value: '1 mi' },
  { label: '2 mi', value: '2 mi' },
  { label: '3 mi', value: '3 mi' },
  { label: '4 mi', value: '4 mi' },
  { label: '5 mi', value: '5 mi' },
  { label: '10 mi', value: '10 mi' },
  { label: '>10 mi', value: '10 mi' },
];

export const PROVIDERS_RATING_FILTER_MENU_ITEMS = [
  { label: 'All', value: 'all' },
  { label: '1', value: '1', icon: Star },
  { label: '2', value: '2', icon: Star },
  { label: '3 and above', value: '3', icon: Star },
  { label: '4 and above', value: '4', icon: Star },
  { label: '5', value: '5', icon: Star },
];

export const PHARMACIES = Object.freeze({
  TITLE_TEXT: 'Pharmacy',
  ABOUT: 'About',

  SEARCH_PLACEHOLDER_TEXT: 'Search by Care',

  IMAGE_ALTERNATE_TEXT: {
    PHARMACY_NAME: 'pharmacyname',
  },
  BUTTON_TEXT: {
    VIEW_ON_MAP: 'View on Maps',
  },
  LABEL_TEXT: {
    LOCATION: 'location',
    CERTIFICATION: 'certification',
    LANGUAGE: 'language',
    COST: 'cost',
    STATUS: 'status',
  },

  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Pharmacy.',
    BY_ID: 'Something went wrong while fetching Pharmacy.',
  },
});
export const PHARMACIES_TABLE_HEADING = [
  { label: 'Pharmacy name', key: 'pharmacyName' },
  { label: 'Address', key: 'address' },
  { label: 'Rating', key: 'rating' },
  { label: 'Distance', key: 'distance' },
  { label: 'Type', key: 'type' },
  { label: 'More' },
];

export const PHARMACIES_TYPE_FILTER_MENU_ITEMS = [
  { label: 'All', value: 'all' },
  { label: 'Community/retail pharmacy', value: 'Community/retail pharmacy' },
  { label: 'Compounding pharmacy', value: 'Compounding pharmacy' },
  {
    label: 'Home infusion therapy provider',
    value: 'Home infusion therapy provider',
  },
  //{ label: 'Institutional pharmacy', value: 'Institutional pharmacy' },
  { label: 'Long-term care pharmacy', value: 'Long-term care pharmacy' },
  { label: 'Mail order pharmacy', value: 'Mail order pharmacy' },
  {
    label: 'Managed care organization (MCO) pharmacy',
    value: 'Managed care organization (MCO) pharmacy',
  },
  { label: 'Specialty care pharmacy', value: 'Specialty care pharmacy' },
  { label: 'Others', value: 'others' },
];

export const PHARMACIES_RATING_FILTER_MENU_ITEMS = [
  { label: 'All', value: 'all' },
  { label: '1', value: '1', icon: Star },
  { label: '2', value: '2', icon: Star },
  { label: '3 and above', value: '3', icon: Star },
  { label: '4 and above', value: '4', icon: Star },
  { label: '5', value: '5', icon: Star },
];
export const PHARMACIES_DISTANCE_FILTER_MENU_ITEMS = [
  { label: 'All', value: 'all' },
  { label: '1 mi', value: '1 mi' },
  { label: '2 mi', value: '2 mi' },
  { label: '3 mi', value: '3 mi' },
  { label: '4 mi', value: '4 mi' },
  { label: '5 mi', value: '5 mi' },
  { label: '10 mi', value: '10 mi' },
  { label: '>10 mi', value: '10 mi' },
];

export const APPOINTMENTS = Object.freeze({
  TITLE_TEXT: 'Appointments',
  DESCRIPTION_TEXT: 'Schedule a visit with a provider of your choice',
  SCHEDULE_VISIT_TEXT: 'Schedule a visit',
  DATE_AND_TIME: 'Date & Time',
  MEDICAL_HISTORY: 'Medical History',
  PAYMENT_DETAILS: 'Payment Details',
  AMOUNT: 'Amount',
  PAYMENT_ID: 'Payment ID',
  PICK_DATE_TIME: 'Pick a date & Time',
  MORNING: 'Morning',
  AFTERNOON: 'Afternoon',
  EVENING: 'Evening',
  VISIT_DETAIL: 'Visit Details',
  VISIT_LINK: 'Visit Link',
  VISIT_STATUS: 'Visit Status',
  REFUND_STATUS: 'Refund Status',
  EDIT: 'edit',
  CHOOSE_DATE: 'Choose Date',

  SEARCH_PLACEHOLDER_TEXT: 'Search by Appointment',

  BUTTON_TEXT: {
    RESCHEDULE_VISIT: 'Reschedule Visit',
    CANCEL_VISIT: 'Cancel Visit',
    JOIN_VISIT: 'Join Visit',
    REFUND_DETAILS: 'Refund Details',
  },
  PLACE_HOLDER: {
    SELECT_DATE: 'Select (Today)',
  },

  IMAGE_ALTERNATE_TEXT: {
    DOCTOR: 'doctor',
    PROVIDER: 'provider',
  },

  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Appointments.',
    BY_ID: 'Something went wrong while fetching appointment details',
    WENT_WRONG_FETCHING_TIME_SLOT_TEXT:
      'Something went wrong while fetching TimeSlotByPractionerId request.',
  },
});

export const APPOINTMENTS_BREADCRUMBDATA = [
  { label: 'Care', route: '/care' },
  { label: 'Appointments' },
];

export const APPOINTMENTS_TABLE_HEADING = [
  { label: 'Recorded on', key: 'recordedOn' },
  { label: 'Time', key: 'time' },
  { label: 'Provider', key: 'provider' },
  { label: 'Type of visit', key: 'typeOfVisitValue' },
  { label: 'Status', key: 'status' },
  { label: 'Facility', key: 'facility' },
  { label: 'More', key: 'more' },
];

export const CARE = Object.freeze({
  TITLE_TEXT: 'Care',
});

export const CAREPLANS = Object.freeze({
  TITLE_TEXT: 'Care Plans',
  SEARCH_PLACEHOLDER_TEXT: 'Search by Care Plans',

  MODAL_DATA: {
    STATUS: 'Status',
    PLAN_PERIOD: 'Plan Period',
    RECORDED_BY: 'Recorded By',
    FACILITY: 'Facility',
    RECORDED_ON: 'Recorded On',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Care Plans.',
    BY_ID: 'Something went wrong while fetching Care Plans Details',
  },
});

export const ASSESSMENTS_TABLE_HEADING = [
  { label: 'Assigned date', key: 'assignedDate' },
  { label: 'Name', key: 'assessmentName' },
  { label: 'Question count', key: 'numberOfQuestions' },
  { label: 'Expiry date', key: 'expiryDate' },
  { label: 'Status', key: 'status' },
  { label: 'Organization name', key: 'orgName' },
  { label: 'More' },
];

export const CAREPLANS_TABLE_HEADING = [
  { label: 'Recorded on', key: 'recordedOn' },
  { label: 'Name', key: 'careplan' },
  { label: 'Status', key: 'status' },
  { label: 'Recorded by', key: 'recordedBy' },
  { label: 'Facility', key: 'facility' },
  { label: 'More' },
];
export const CAREPLANS_BREADCRUMBDATA = [
  { label: 'Care', route: '/care' },
  { label: 'Care Plans' },
];

export const ASSESSMENTS_BREADCRUMBDATA = [
  { label: 'Care', route: '/care' },
  { label: 'Assessments' },
];

export const CARETEAM = Object.freeze({
  TITLE_TEXT: 'Care Team',

  ASSOCIATE_CARE_PLANS: 'Associated Care Plans',
  OBESITY_NARRATIVE: 'Obesity Narrative',
  VIEW_DETAILS: 'View Details',
  INTERVENTIONS: 'Interventions',

  SEARCH_PLACEHOLDER_TEXT: 'Search by Care Team',

  MODAL_DATA: {
    STATUS: 'Status',
    PHONE_NUMBER: 'Phone Number',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    REASON: 'Reason',
    NOTE: 'Note',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Care Team.',
    BY_ID: 'Something went wrong while fetching Care Teams Details',
  },
});

export const CARETEAM_TABLE_HEADING = [
  { label: 'Team Name', key: 'name' },
  { label: 'Category', key: 'category' },
  { label: 'Status', key: 'status' },
  { label: 'Contact', key: 'contact' },
  { label: 'More' },
];
export const CARETEAM_BREADCRUMBDATA = [
  { label: 'Care', route: '/care' },
  { label: 'Care Team' },
];
export const FINANCIAL = Object.freeze({
  TITLE_TEXT: 'Financial',
});

export const FORMULARY = Object.freeze({
  TITLE_TEXT: 'Formulary',
  SEARCH_PLACEHOLDER_TEXT: 'Search formulary by name',
  IMAGE_ALTERNATE_TEXT: {
    formulary: 'Formulary',
  },

  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Formulary.',
    BY_ID: 'Something went wrong while fetching Formulary Details',
  },
});

export const FORMULARY_BREADCRUMBDATA = [
  { label: 'Medical', route: '/medical' },
  { label: 'Formulary' },
];

export const LEGAL = Object.freeze({
  TITLE_TEXT: 'Legal',
});

export const ERROR_MSGS = Object.freeze({
  REQUIRED_FIELD: {
    MEMBER_ID: 'Member ID is required',
    FIRST_NAME: 'First Name is required',
    LAST_NAME: 'Last Name is required',
    DATE_OF_BIRTH: 'Date of Birth is required',
    SSN: 'SSN is required',
    ZIPCODE: 'Zip Code is required',
    EMAIL: 'Email is required',
    PHONE_NUMBER: 'Please enter your phone number',
    PASSWORD: 'Please enter password',
  },

  MEMBER_ID_VALID: 'Please enter a valid 9 digit Member ID',
  FIRST_NAME_INVALID: 'This is not a valid First Name',
  LAST_NAME_INVALID: 'This is not a valid Last Name',
  INVALID_SSN: 'Invalid SSN',
  INVALID_ZIPCODE: 'Invalid Zipcode',
  NOT_VALID_EMAIL: 'This is not a valid email',
  PHONE_NUMBER_TEN_DIGIT: 'Please enter a 10 digit phone number',
  INVALID_PHONE: 'Invalid phone number',
  PASSWORD_LENGTH_8: 'Password must be 8 or more characters long',
  PASSWORD_MUST_INCLUDE:
    'Must include an upper and lower case letter, number and symbol',
  CONFIRM_PASSWORD: 'Please confirm the entered password',
  PASSWORD_NOT_MATCH: 'passwords do not match',
  USER_EMAIL_ALREADY_EXIST: 'User email already exists.',
  USER_PHONE_ALREADY_EXIST: 'User phone number already exists.',
  ACCOUNT_CREATE_SUCCESS: 'Account Created Successfully.',
  ACCOUNT_VERIFY_SUCCESS: 'User Verified Successfully.',
  WENT_WRONG_CREATE_ACCOUNT: 'Something went wrong while creating new account.',
  REACH_CUSTOMER_CARE:
    'Invalid account details, please reach out to customer care for more information.',

  WENT_WRONG_REGENERATING_OTP: 'Something went wrong while regenerating OTP.',
  WENT_WRONG_GENERATING_OTP: 'Something went wrong while generating OTP',
  WENT_WRONG_VALIDATING_OTP: 'Something went wrong while validaing OTP.',
  WRONG_OTP: 'Wrong OTP entered. Please retry.',
  OTP_EXPIRED: 'OTP Expired. Please regenerate and try again.',
  PHONE_ALREADY_EXIST:
    'User phone number already exists. Please enter a different phone number.',
});

export const PLAN__COVERAGE = Object.freeze({
  TITLE_TEXT: 'Plan Coverage',
  DOWNLOAD_ICON: 'downloadicon',

  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching PlanCoverage.',
  },
});
export const PLAN_COVERAGE_BREADCRUMBDATA = [
  { label: 'Account', route: '/account' },
  { label: 'Plan Coverage' },
];

export const FIND_CARE = Object.freeze({
  TITLE_TEXT: 'Find Care',
  ADD_LOCATION: 'Add your location',
  CURRENT_LOCATION: 'Use current location',
  RECENTS: 'Recents',
  TOP_LOCALITIES: 'Top Localities',
  DATE_AND_TIME: 'Date & Time',
  VISIT_DETAILS: 'Visit Details',

  LABEL: {
    PROVIDERS: 'Providers',
    PHARMACIES: 'Pharmacies',
  },
  PLACE_HOLDER: {
    SEARCH_FOR_AREA: 'Search for area, street name',
  },
});

//Temporarily adding locations

export const FIND_CARE_RECENT_LOCATIONS = [
  {
    name: 'Zolo Maple',
    address:
      '1st Cross Road, Tavarekere, Kaveri Layout, S.G. Palya,Bengaluru, Karnataka, India',
  },
  {
    name: 'Zolo Zen',
    address:
      'Sandyagappa Reddy Layout, Coffee Board Layout, Nagavara, Bengaluru, Karnataka, India',
  },
];

//Temporarily adding locations
export const FIND_CARE_TOP_LOCALITIES = [
  {
    name: 'Zolo Maple',
    address:
      '1st Cross Road, Tavarekere, Kaveri Layout, S.G. Palya,Bengaluru, Karnataka, India',
  },
  {
    name: 'Zolo Zen',
    address:
      'Sandyagappa Reddy Layout, Coffee Board Layout, Nagavara, Bengaluru, Karnataka, India',
  },
];

/************/

export const FIND_CARE_BREADCRUMBDATA = [
  { label: 'Care', route: '/care' },
  { label: 'Find Care' },
];

export const DASHBOARD = Object.freeze({
  TITLE_TEXT: 'Records',
  NOTIFICATION_TEXT: 'Reminders',
});

export const TERM_CONDITIONS = Object.freeze({
  VIEW_TERM: 'View T&C',
  TERMS_CONDITIONS: 'Terms and Conditions',
  PRIVACY_POLICY: 'Privacy Policy',
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching T&C',
  },
});

export const SERVICE_CONTAINER = Object.freeze({
  VIEW_ALL: 'View All',
});

export const CLAIMS_DASHBOARD = Object.freeze({
  CLAIMS_SUMMARY: 'Claims Summary',
  TOTAL_CLAIM_AMOUNT: 'Total Claim Amount',
  VIEW_BREAKUP_TEXT: 'Click on expand to view breakup',
  VIEW_HIDE_BREAKUP_TEXT: 'Click on hide to hide breakup',
  EXPAND: 'Expand',
  COLLAPSE: 'Collapse',
});

export const UPCOMING_CARD = Object.freeze({
  UPCOMING: 'Upcoming',
  VIRTUAL_VISIT_TITLE: 'Virtual Visit',
  BILLS: 'Bills',
  DUE_NEXT_WEEK: 'Due Next Week',
  PAY_BILL: 'Pay Bill',
  VIEW_DETAILS: 'View Details',
  CONSENTS: 'Consents',
  BUTTON_TEXT: {
    JOIN_VISIT: 'Join Visit',
    VIEW_DETAILS: 'View Details',
  },
});

export const COVERAGE = Object.freeze({
  TITLE_TEXT: 'Coverage and benefits',
  PRICE_LIST: 'Price List',
  SEARCH_BY_TEXT: 'Search by second column value',
  SEARCH_PLACEHOLDER_TEXT: 'Search by Coverage',

  MODAL_DATA: {
    STATUS: 'Status',
    RECORDED_ON: 'Recorded On',
    POLICY_NUMBER: 'Policy number',
    SUBSCRIBER_ID: 'Subscriber ID',
    SUBSCRIBER_NAME: 'Subscriber Name',
    RELATIONSHIP: 'Relationship',
    PLAN_TYPE: 'Plan Type',
    PLAN_ID: 'Plan ID',
    COVERAGE_TYPE: 'Coverage Type',
    ISSUER_ORGANISATION: 'Issuer Organisation',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    TOTAL_AMOUNT: 'Total Amount',
    CONTACT_NAME: 'Contact name',
    CONTACT_PHONE_NUMBER: 'Contact phone number',
    CONTACT_ADDRESS: 'Contact Address',
    NOTE: 'Note',
    DOCUMENTS: 'Document',
  },
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching coverages.',
    BY_ID: 'Something went wrong while fetching coverages Details',
  },
});

export const COVERAGE_BREADCRUMBDATA = [
  { label: 'Financial', route: '/financial' },
  { label: 'Coverage and benefits' },
];

export const COVERAGE_TABLE_HEADING = [
  { label: 'Coverage', key: 'coverage', width: 500 },
  { label: 'Status', key: 'status', width: 150 },
  { label: 'Start date', key: 'startDate', width: 150 },
  { label: 'Expiry date', key: 'expiryDate', width: 150 },
  { label: 'Price list', key: 'priceList', width: 150 },
  { label: 'More' },
];
export const PRICE_LIST = Object.freeze({
  TITLE_TEXT: 'Price List',
  SEARCH_BY_TEXT: 'Search by name, code, NPI or plan name',
  SEARCH_BY: 'Search by Procedure or Drug name',
  NOT_FOUND_TEXT: 'Coverage Price List',
  PLEASE_SELECT_PLAN: 'Please select the plan to view the pricelist',
  IN_NETWORK_RATE: 'In-Network Rate',
  OUT_OF_NETWORK: 'Out of Network',
  PRESCRIPTION_DRUG: 'Prescription Drug',
  DOWNLOAD: 'Download',
  VIEW_PRICE_LIST: 'View Price List',

  SELECT_PLAN: 'Select Plan',
  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Coverage details',
    BY_ID: 'Something went wrong while fetching Price List details',
    ON_DOWNLOAD: 'Something went wrong while downloading the file',
    WENT_WRONG_PRICE_LIST:
      'Something went wrong while fetching Coverage Price List.',
  },
});

export const CAREPLAN_COMPONENT = Object.freeze({
  LABEL_TEXT: {
    PROBLEMS: 'Problems',
    GOALS: 'Goals',
    ACTIVITIES: 'Activities',
    CARE_TEAM: 'Care Team',
    OPTIONS: 'Options',
    HISTORICAL_RECORD: 'Historical Records',
  },

  ON_ERROR_TEXT: {
    WENT_WRONG_TEXT: 'Something went wrong while fetching Formulary.',
    BY_ID: 'Something went wrong while fetching Formulary Details',
  },
});

export const CONFIRMATION_MODAL = Object.freeze({
  VISIT_RESCHEDULE_SUCCESS_TEXT: 'Visit rescheduled successfully!',
  BUTTON_TEXT: {
    YES: 'Yes',
    NO: 'No',
    VIEW_DETAILS: 'View Details',
    CLOSE: 'Close',
  },
});

export const HOME_BANNER = Object.freeze({
  TITLE_TEXT: 'Find Care',
  IMAGE_ALTERNATE_TEXT: {
    Find_Care: 'find-care',
  },
});

export const LOCATION = Object.freeze({
  ADD_LOCATION: 'Add location',
  EDIT: 'Edit',
});

export const OTP_VERIFICATION = Object.freeze({
  PHONE_NUMBER: 'Phone Number',
  EDIT_PHONE: 'Enter phone number',
  CONFIRM_SEND_OTP: 'We’ll send a OTP to confirm your number',
  HAVE_ACCOUNT: 'Have an account?',
  OTP_RESEND_SUCCESS: 'OTP Resent Successfully.',
  OTP_SEND_SUCCESS: 'OTP Sent Successfully.',
  RESEND_TIMER: 'Request new code in 00',

  LOGIN: 'Login',
  BUTTON_TEXT: {
    CANCEL: 'Cancel',
    SAVE_CHANGES: 'Save Changes',
  },
});
export const NOT_FOUND = Object.freeze({
  IMAGE_ALTERNATE_TEXT: {
    ERROR_IMG: 'errorImg',
  },
  BUTTON_TEXT: {
    REFRESH: 'Refresh',
    BAC_TOKEN_EXPIRY: 'Click here',
  },
});
export const MEDICAL_HISTORY_FINDCARE = Object.freeze({
  MEDICAL_HISTORY: 'Medical History',
  NAME_OF_DIAGNOSIS_ALLERGIES: 'Name of Diagnosis/Allergies',
  MEDICATION_TAKEN: 'Medication if Taken',
  FREQUENCY: 'Frequency',
  CHOOSE: 'Choose',
  STILL_USING: 'Still Using',
  ADDITIONAL_NOTE: 'Additional notes',
  DIAGNOSIS_ALLERGIES: 'Diagnosis / Allergies',
  ADD_ANOTHER_DIAGNOSIS: 'Add Another Diagnosis',
  TERM_POLICIES_TEXT: 'I agree to all',
  POLICIES_TERM_HIGHLIGHTED_TEXT: 'policies and terms',
  TERM_POLICIES_REMAINING_TEXT:
    'attest that the information provided is true and correct to best of your knowledge.',
  PLACE_HOLDER: {
    COMMENT: 'Comment',
  },
});

export const IMAGE_ALTERNATE_TEXT = Object.freeze({
  PATIENT_IMG: 'patientimg',
  ID_CARD: 'idcard',
  AFFILIATE_LOGO: 'Affiliate Logo.',
  NOT_FOUND_ICON: 'notfoundicon',
  TOOLTIP: 'tooltip',
  ICON: 'icon',
});

export const PRICE_LIST_HEADINGS = [
  'serviceName',
  'billingCode',
  'codingSystem',
  'providersNpi',
  'negotiatedRate',
  'negotiatedType',
];
export const OUT_NET_PRICE_LIST_HEADINGS = [
  'serviceName',
  'billingCode',
  'codingSystem',
  'providersNpi',
  'allowedAmount',
];
